import http from '@/services/axios'
import { cloneDeep } from 'lodash'

const defaultBaseUrl = http.defaults.baseURL

const estados = {
  getAll: (convenio = null) => {
    return http.get('/estados')
  },
  getOneById: (id = null) => {
    return http.get('/estados/' + id)
  }
}

const cidades = {
  getAllByEstadoId: async (estadoId) => {
    http.defaults.baseURL = null

    let response = await http.get('/static/cache/cidades.json')
    let cidades = {data: []}

    response.data.forEach((cidade) => {
      if (cidade.id.toString().indexOf(estadoId) === 0) {
        cidades.data.push(cidade)
      }
    })

    http.defaults.baseURL = defaultBaseUrl

    return cidades
  },
  getOneById: async (id = null) => {
    http.defaults.baseURL = null

    let response = await http.get('/static/cache/cidades.json')
    let cidades = {data: []}

    response.data.forEach((cidade) => {
      if (cidade.id.toString().indexOf(id) === 0) {
        cidades.data.push(cidade)
      }
    })

    http.defaults.baseURL = defaultBaseUrl

    return cidades
  }
}

const cnaes = {
  getAll: async () => await http.get('/geral/cnaes')
}

const cep = {
  getOneByNumero: async (numero = null) => {
    let cep = numero.replace(/[^0-9]/g, '')
    if (cep.length === 0) return { data: { erro: true } }
    let response = await fetch('https://viacep.com.br/ws/' + cep + '/json/')
    return response.json()
  }
}

export default { estados, cidades, cnaes, cep }



// WEBPACK FOOTER //
// ./src/services/geral.js